import { AbstractControl, ValidationErrors } from '@angular/forms';

export const valueMatchValidator = (inputA: string, inputB: string) => {
  return (group: AbstractControl): ValidationErrors | null => {
    const controlB = group.get(inputB);
    const inputAValue = group.get(inputA)?.value;
    const inputBValue = controlB?.value;

    if (inputAValue === inputBValue) {
      if (controlB?.hasError('match')) {
        const { match: _match, ...rest } = controlB.errors ?? {};
        controlB.setErrors(Object.keys(rest).length ? rest : null);
      }
      return null;
    }

    controlB?.setErrors({ ...(controlB.errors ?? {}), match: true });
    return { match: true };
  };
};

export const passwordComplexityValidator = (control: AbstractControl): ValidationErrors | null => {
  const password = control.value;

  if (password == null || typeof password !== 'string') {
    return { complexity: true };
  }
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasNonalphas = /\W/.test(password);

  if (!hasUpperCase || !hasLowerCase || !hasNumbers || !hasNonalphas) {
    return { complexity: true };
  }

  return null;
};